import { Outlet, createFileRoute } from '@tanstack/react-router'

import { listProjectsOptions } from '@/api/codegen/@tanstack/react-query.gen'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId',
)({
  component: () => <Outlet />,
  loader: async ({
    context: { queryClient },
    params: { companyId, projectId, spaceId },
  }) => {
    const projects = await queryClient.ensureQueryData(
      listProjectsOptions({
        path: {
          spaceID: spaceId,
        },
      }),
    )
    const project = projects.items.find(({ id }) => id === projectId)

    return {
      breadcrumbTitle: project?.name || '',
      breadcrumbPath: `/${companyId}/spaces/${spaceId}/projects/${projectId}/dashboard`,
    }
  },
})
